export const  ROLE = {
    admin: { id: 'admin', name: 'Administrador Master'},
    adminEmpresa: { id: 'admin-empresa', name: 'Administrador Empresa'},
    gestor: { id: 'gestor', name: 'Gestor'},
    operador: { id: 'operador', name: 'Operador'},
    registrator: {id: 'registrator', name: 'Assistente de Entrada de Indicadores'},
    restaurantDashboardManager: {id: 'restaurant-dashboard-manager', name: 'Gestor de Dashboard do Restaurante'},
}
export const roles = [
    ROLE.admin, ROLE.adminEmpresa, ROLE.gestor, ROLE.operador, ROLE.registrator, ROLE.restaurantDashboardManager
]